import type { MedplumClient } from '@medplum/core';
import type { Coverage } from '@medplum/fhirtypes';

/** Search params aligned with provider AccessPolicy (`?_compartment=%care_team`). */
export function patientCompartmentSearch(patientId: string): { _compartment: string } {
  return { _compartment: `Patient/${patientId}` };
}

/** Load Coverage for a patient (beneficiary, subscriber, and care-team compartment). */
export async function searchCoveragesForPatient(
  medplum: MedplumClient,
  patientId: string,
): Promise<Coverage[]> {
  const patientRef = `Patient/${patientId}`;
  const empty: Coverage[] = [];
  const [bySubscriber, byBeneficiary, byCompartment] = await Promise.all([
    medplum.searchResources('Coverage', { subscriber: patientRef, _count: '10' }).catch(() => empty),
    medplum.searchResources('Coverage', { beneficiary: patientRef, _count: '10' }).catch(() => empty),
    medplum
      .searchResources('Coverage', { ...patientCompartmentSearch(patientId), _count: '10' })
      .catch(() => empty),
  ]);
  const seen = new Set<string>();
  return [...bySubscriber, ...byBeneficiary, ...byCompartment].filter((c) => {
    if (!c.id || seen.has(c.id)) return false;
    seen.add(c.id);
    return true;
  });
}
